import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { PageListConfig } from './page-config-api';
import { DynamicGridComponent } from '../../fw/dynamic-grids/dynamic-grid.component';

@Component({
    selector: 'fw-page-list',
    template: require('./page-list.component.html'),
    styles: [require('./page-list.component.css')]
})
export class PageListComponent implements OnInit {
    @Input() config = new PageListConfig();
    @ViewChild(DynamicGridComponent, {static: false}) grid: DynamicGridComponent;

    @Output() btnHeaderBarClick = new EventEmitter<any>();
    @Output() gridRowDoubleClick = new EventEmitter<number>();

    errorMessage: string;
    operation: string;

    constructor() { }

    ngOnInit() {

    }

    setGridData(data: Array<any>) {
        this.grid.showData(data);
    }

    btnHeaderBarClicked(event) {
        this.btnHeaderBarClick.emit(event);
    }

    gridRowDoubleClicked(event) {
        this.gridRowDoubleClick.emit(event);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Scripts/fw/pages/page-list.component.ts